import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
class TicketChatMessageItemSeperator extends Vue {
  @Prop({ type: [String, null], required: true })
  date: string | null;

  @Prop({ type: [String], required: false })
  label: string;

  @Prop({ type: [Boolean], required: false, default: false })
  isClose: boolean;
}

export default TicketChatMessageItemSeperator;


// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-chat-message-item-seperator/index.ts